import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { DisableEnableControls, GetFormatedDateWithTime, loadLookupFromStaticDataSource } from '../../../common/Utils'
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import PrimaryTab from "./tabs/PrimaryTab";
import StatusTab from "./tabs/StatusTab";
import UOMTab from "./tabs/UOMTab";
import UserDefinedTab from "./tabs/UserDefinedTab";
import LocationsTab from "./tabs/LocationsTab";
import data from "../../../assets/apiRoutes.json";
import { IM } from "../../../const/constants";
import {RecordTypes, TransactionStatus, YesNo,CalcMethod as CalcMethodEnum,PriceSource as PriceSourceEnum,PriceMethod as PriceMethodEnum } from "../../../enum/Enum";
import { MESSAGES } from "../../../common/Messages";
import ReorderTab from "./tabs/ReorderTab";
import CostPriceTab from "./tabs/CostPriceTab";
import { CalcMethod, CommissionBases, CostBasisMethodFlag, optionsYesNo, PriceMethod, PriceSource, RoundingMethod, TradeDisc,
InventoryQuantitySource,
WeightBasisFlag,
ReceiptUomDefault,
ShipmentUomDefault,
RfReceiptValidation,
RfShipmentValidation,
LotStatus,
ItemSourceFlag,
TaxStatus,
ReorderMethodFlag
 } from "../../../const/Lookup";
import ItemDataEntryPopup from "../itemDataEntry/common/ItemDataEntryPopup";

var skipDataLoading = false;
var perviousItemType = null;
function Form(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        RowId: '00000000-0000-0000-0000-000000000000',
        KeySequence: null,
        CreationDateTime: null,
        CreationUserId: null,
        LastUpdateDateTime: null,
        LastUpdateUserId: null,
        CompanyId: null,
        Module: IM,
        RecordType: RecordTypes.Receipt,
        RItem: null,
        LotCode: null,
        Description1: null,
        Description2: null,
        Status: TransactionStatus.Active,
        Comment: null,
        RVendor: null,
        RouteCode: null,
        RLocation: null,
        LotSizeCode: null,
        LotProjectionCode: null,
        LotUnitUomFlag: null,
        LotUomDefault: null,
        LotUnitsPerItemUnit: null,
        RoyaltyFlag: null,
        RoyaltyUnitCost: null,
        RoyaltyUnitPrice: null,
        RoyaltyAddToPriceFlag: null,
        StageFlag: null,
        ReorderInventoryMinimumQty: null,
        ReorderInventoryMaximumQty: null,
        ReorderQuantityEoqCalculated: null,
        ReorderQuantityOrderMultiple: null,
        ReorderSafetyQuantity: null,
        ReorderLeadTime: null,
        CostBasisMethodFlag: CostBasisMethodFlag[0].key,
        AverageCost: null,
        StandardCost: null,
        RPriceTable: null,
        CorePrice: null,
        MaximumPriceLevelForDiscount: null,
        TradeDiscountOnSpecialPriceAr: null,
        EarlyPayDiscountFlag: null,
        CostAllocationFactor: null,
        DateIntroduced: new Date(),
        ReorderQuantityEntered: null,
        DateAvailable: new Date(),
        ReorderMethodFlag: YesNo.No,
        DateExpiration: null,
        ReorderMinimumDaysOnHand: null,
        UserDefinedCode1: null,
        ReorderMaximumDaysOnHand: null,
        UserDefinedCode2: null,
        ClassCode: null,
        UserDefinedCode3: null,
        SubClassCode: null,
        UserDefinedCode4: null,
        RProductCategory: null,
        UserDefinedCode5: null,
        ROemManufactureId: null,
        UserDefinedCode6: null,
        UserDefinedCode7: null,
        VendorItemCode: null,
        UserDefinedCode8: null,
        PhysicalCountCode: null,
        UserDefinedCode9: null,
        OemManufacturerCode: null,
        UserDefinedCode10: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedReference6: null,
        UserDefinedReference7: null,
        UserDefinedReference8: null,
        UserDefinedReference9: null,
        UserDefinedReference10: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedDate6: null,
        UserDefinedDate7: null,
        UserDefinedDate8: null,
        UserDefinedDate9: null,
        UserDefinedDate10: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedQuantity6: null,
        UserDefinedQuantity7: null,
        UserDefinedQuantity8: null,
        UserDefinedQuantity9: null,
        UserDefinedQuantity10: null,
        InventoryUnitUom: null,
        PiecesPerUnitUom: null,
        PiecesPerUnitQuantity: null,
        UnitsPerPackageUom: null,
        UnitsPerPackageQuantity: null,
        PackagesPerShippingUnitUom: null,
        PackagesPerShippingUnitQty: null,
        UnitVolumeUom: null,
        UnitVolumeQuantity: null,
        UnitAreaUom: null,
        UnitAreaQuantity: null,
        UnitValueUom: null,
        NetWeightUom: null,
        NetWeightQuantity: null,
        GrossWeightUom: null,
        UnitValueQuantity: null,
        GrossWeightQuantity: null,
        OnHand: null,
        InOrdered: null,
        OutOrdered: null,
        InReceiving: null,
        OutShipped: null,
        InBackOrder: null,
        OutBackOrder: null,
        InUnavailable: null,
        OutUnavailable: null,
        InFuture: null,
        OutFuture: null,
        Available: null,
        NetAvailable: null,
        StorageBillingStartDate: null,
        StorageBillingEndDate: null,
        RRateSchedule: null,
        PopupMessage: null,
        LastCost: null,
        Size1: null,
        RBuyer: null,
        Size2: null,
        StorageBilledDateLast: null,
        StorageBilledDateNext: null,
        PriceSource: PriceSource[2].key,
        PriceMethod: PriceMethod[0].key,
        CalcMethod: null,
        PriceLevelA: null,
        PriceLevelB: null,
        PriceLevelC: null,
        PriceLevelD: null,
        PriceLevelE: null,
        RGlDepartment: null,
        RGlFund: null,
        RCaJob: null,
        PriceBasis: null,
        RFees: null,
        ItemsUpcCode: null,
        RfReceiptValidation: null,
        RfShipmentValidation: null,
        InTransactionNumber: null,
        DateLastReceipt: null,
        RParticipant: null,
        CommissionBasis: CommissionBases[1].key,
        CommissionAmount: null,
        RoundingMethod: RoundingMethod[2].key,
        RoundingFactor: 0.0100,
        AlternateStandardCost: null,
        AlternateAverageCost: null,
        AlternateLastCost: null,
        PrevStorageBilledDateLast: null,
        PrevStorageBilledDateNext: null,
        RecurringStorage: null,
        ProgressiveCurrentRate: null,
        ProgressiveLastRate: null,
        ProgressivePreviousLastRate: null,
        ProgressiveBillingCount: null,
        RLotSource: null,
        OversellPercentage: null,
        SaleMaxQuantity: null,
        Record: null,
        ItemCode: null,
        RProfile: null,
        RWarehouse: null,
    };
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);
    const [loadPriceDataGrid, setLoadPriceDataGrid] = useState(false);
    const [showPopup, setShowPopup] = useState({id:null,visible:false});
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const costPriceGridRef = useRef(null);
    
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    
    const handleTabSelection = (e) => {
        setSelectedTabIndex(e.selectedIndex);
        // Resize grid when Cost/Price tab (index 2) is selected
        if (e.selectedIndex === 2 && costPriceGridRef.current && costPriceGridRef.current.current && costPriceGridRef.current.current.instance) {
            setTimeout(() => {
                if (typeof costPriceGridRef.current.current.instance === 'function') {
                    const instance = costPriceGridRef.current.current.instance();
                    if (instance && typeof instance.updateDimensions === 'function') {
                        instance.updateDimensions();
                    }
                }
            }, 100);
        }
    };
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.RowId == "00000000-0000-0000-0000-000000000000") {
                await insertLot();
            }
            else {
                await updateLot();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setLoadPriceDataGrid(!loadPriceDataGrid);
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const updateDateFormats = (fields) => {
        fields.DateIntroduced = GetFormatedDateWithTime(formFields.DateIntroduced);
        fields.DateAvailable = GetFormatedDateWithTime(formFields.DateAvailable);
        fields.DateExpiration = GetFormatedDateWithTime(formFields.DateExpiration);
        fields.StorageBillingStartDate = GetFormatedDateWithTime(formFields.StorageBillingStartDate);
        fields.StorageBillingEndDate = GetFormatedDateWithTime(formFields.StorageBillingEndDate);
        fields.UserDefinedDate1 = GetFormatedDateWithTime(formFields.UserDefinedDate1);
        fields.UserDefinedDate2 = GetFormatedDateWithTime(formFields.UserDefinedDate2);
        fields.UserDefinedDate3 = GetFormatedDateWithTime(formFields.UserDefinedDate3);
        fields.UserDefinedDate4 = GetFormatedDateWithTime(formFields.UserDefinedDate4);
        fields.UserDefinedDate5 = GetFormatedDateWithTime(formFields.UserDefinedDate5);
        fields.UserDefinedDate6 = GetFormatedDateWithTime(formFields.UserDefinedDate6);
        fields.UserDefinedDate7 = GetFormatedDateWithTime(formFields.UserDefinedDate7);
        fields.UserDefinedDate8 = GetFormatedDateWithTime(formFields.UserDefinedDate8);
        fields.UserDefinedDate9 = GetFormatedDateWithTime(formFields.UserDefinedDate9);
        fields.UserDefinedDate10 = GetFormatedDateWithTime(formFields.UserDefinedDate10);
        fields.StorageBilledDateLast = GetFormatedDateWithTime(formFields.StorageBilledDateLast);
        fields.StorageBilledDateNext = GetFormatedDateWithTime(formFields.StorageBilledDateNext);
        fields.DateLastReceipt = GetFormatedDateWithTime(formFields.DateLastReceipt);
        fields.PrevStorageBilledDateLast = GetFormatedDateWithTime(formFields.PrevStorageBilledDateLast);
        fields.PrevStorageBilledDateNext = GetFormatedDateWithTime(formFields.PrevStorageBilledDateNext);
        return fields;
    }
    const insertLot = async () => {
        try {
            let fields = updateDateFormats(formFields);

            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.IM.Lot.Insert}`,fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    RowId: response.data.ROWID,
                    Record: response.data.RECORD
                }));
                notify(
                    {
                        message: "Lot Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            }
        } catch (error) {
            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
            else {
                notify(
                    {
                        message: MESSAGES.ERROR_FORM_SUBMISSION,
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateLot = async () => {
        try {
            let fields = updateDateFormats(formFields);
            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${data.IM.Lot.Update}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data || !response.data.ERRORS.length > 0) {
                notify(
                    {
                        message: "Lot Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            }


        } catch (error) {
            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                var hasWarning = false;
                var hasConfirmation = false;
                var errorMessage = "";
                var errorsArray = [];

                for (let i = 0; i < error.response.data.ERRORS.length; i++) {

                    if (error.response.data.ERRORS[i].startsWith("[ItemTypeWarning]")) {
                        hasWarning = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeWarning]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else if (error.response.data.ERRORS[i].startsWith("[ItemTypeConfirmation]")) {
                        hasConfirmation = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeConfirmation]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else {
                        errorsArray.push(error.response.data.ERRORS[i]);
                    }
                }

                if (errorsArray.length > 0) {
                    const errorHtml = errorsArray.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
                else {
                    if (hasWarning) {
                        alert(errorMessage, "Warning");
                        setformFields(prevFields => ({
                            ...prevFields,
                            ItemType: perviousItemType
                        }));

                    }
                    else if (hasConfirmation) {

                    }
                }
            }
            else {
                notify(
                    {
                        message: MESSAGES.ERROR_FORM_SUBMISSION,
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad = (formRefs) => {
        primaryFormLoad(formRefs);
        handleUOMFormLoad(formRefs);
        statusFormLookupsLoad(formRefs);
        reorderFormLoad(formRefs);
        costPriceFormLoad(formRefs);
    }

    const enableDisableControls = (name, disabled, formRefs) => {
        if (formRefs && formRefs.current && formRefs.current[name]) {
            const ref = formRefs.current[name];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    instance.option('disabled', disabled);
                }
            }
        }
    }
    const primaryFormLoad = (formRefs) => {
        loadLookupFromStaticData(formRefs, "Status", LotStatus);
        loadLookupFromStaticData(formRefs, "ItemSourceFlag", ItemSourceFlag);
        loadLookupFromStaticData(formRefs, "TaxStatus", TaxStatus);
        if (formFieldsRef.current.RowId !== "00000000-0000-0000-0000-000000000000") {
            enableDisableControls('RProfile', true);
            enableDisableControls('RWarehouse', true);
        }
    }

    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
       loadLookupFromStaticDataSource(name,dataSource,formFields,formRefs);
    };
    const handleReset = () => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
        }
    };

    const DeleteClick = async () => {
        let result = confirm(`<i>${MESSAGES.DELETE_CONFIRM}</i>`, "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try {
                    const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.IM.Lot.Delete}`, formFields.RowId, {
                        headers: {
                            'Content-Type': 'application/json',
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        },
                    });
                    if (!response.data.ERRORS.length > 0) {
                        notify(
                            {
                                message: MESSAGES.DELETE_SUCCESS,
                                width: 100,
                            },
                            'success',
                            3000,
                        );
                        setLoadPanelVisible(false);
                        history.push('/om/codes/lot-data-entry-list');
                    }
                    else {
                        setLoadPanelVisible(false);
                        const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: MESSAGES.ERROR,
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                }
                catch (error) {

                    setLoadPanelVisible(false);

                    if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                        const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                    else {
                        notify(
                            {
                                message: MESSAGES.ERROR_FORM_SUBMISSION,
                                width: 100,
                            },
                            'error',
                            3000,
                        );
                    }
                }
            }
        })
    }

    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        enableDisableControls('RItem', false);
        history.push('/om/codes/lot-data-entry-create');
    }

    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            axios.get(`${window._env_.REACT_APP_APIS}/${data.IM.Lot.GetLot}?RowId=${id}&Module=${IM}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                if (responseData.RowId) {
                    skipDataLoading = true;
                    responseData.INVENTORYUNITNOTUSED = 1;
                    setformFields(responseData);
                    enableDisableControls('RItem', true);
                    skipDataLoading = false;
                }
                else {
                    console.error(MESSAGES.FETCH_ERROR);
                }
            });


        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
    }, [props.id]);
    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);

    const setReorderControlls = (disabled,formRefs) => {
        DisableEnableControls('ReorderInventoryMinimumQty', disabled,formRefs);
        DisableEnableControls('ReorderInventoryMaximumQty', disabled,formRefs);
        DisableEnableControls('ReorderMinimumDaysOnHand', disabled,formRefs);
        DisableEnableControls('ReorderMaximumDaysOnHand', disabled,formRefs);
        DisableEnableControls('ReorderQuantityEntered', disabled,formRefs);
        DisableEnableControls('ReorderQuantityEoqCalculated', disabled,formRefs);
        DisableEnableControls('ReorderQuantityOrderMultiple', disabled,formRefs);
        DisableEnableControls('ReorderSafetyQuantity', disabled,formRefs);
        DisableEnableControls('ReorderLeadTime', disabled,formRefs);
        if (disabled) {
            setformFields(prevState => ({
                ...prevState,
                ReorderInventoryMinimumQty: null,
                ReorderInventoryMaximumQty: null,
                ReorderMinimumDaysOnHand: null,
                ReorderMaximumDaysOnHand: null,
                ReorderQuantityEntered: null,
                ReorderQuantityEoqCalculated: null,
                ReorderQuantityOrderMultiple: null,
                ReorderSafetyQuantity: null,
                ReorderLeadTime: null
            }));
        }
    }
    const goBack = () => {
        history.push("/om/codes/lot-data-entry-list");
    };

    const handleFieldChange = useCallback((name, value, e,formRefs) => {
        let currentFormFields = formFieldsRef.current;
        if (name == "ReorderMethodFlag") {
            if (value == YesNo.No) {
                setReorderControlls(true,formRefs);
            }
            else {
                setReorderControlls(false,formRefs);
            }
        }
        if (name == "RateSource" && !skipDataLoading) {
            if (value == "L") {
                if (formRefs && formRefs.current && formRefs.current['RRateSchedule']) {
                    const ref = formRefs.current['RRateSchedule'];
                    if (typeof ref.instance === 'function') {
                        const instance = ref.instance();
                        if (instance && typeof instance.option === 'function') {
                            instance.option('disabled', true);
                        }
                    }
                }
                setformFields(prevState => ({
                    ...prevState,
                    RRateSchedule: null,
                }));
            }
            else {
                if (formRefs && formRefs.current && formRefs.current['RRateSchedule']) {
                    const ref = formRefs.current['RRateSchedule'];
                    if (typeof ref.instance === 'function') {
                        const instance = ref.instance();
                        if (instance && typeof instance.option === 'function') {
                            instance.option('disabled', false);
                        }
                    }
                }
            }
        }

        if (name == "RateSelection" && !skipDataLoading) {
            //loadRateScheduleLookupFromDataSource();
            setformFields(prevState => ({
                ...prevState,
                RRateSchedule: null,
            }));
        }
        // Manually use PascalCase field names
        if (name == "GrossMinusNet") {
            let calculatedValue = currentFormFields.NetWeightQuantity + value;
            if (formRefs && formRefs.current && formRefs.current.GrossWeightQuantity) {
                const ref = formRefs.current.GrossWeightQuantity;
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('value', calculatedValue);
                    }
                }
            }
        }
        if (name == "NetWeightQuantity") {
            let calculatedValue = currentFormFields.GrossMinusNet + value;
            if (formRefs && formRefs.current && formRefs.current.GrossWeightQuantity) {
                const ref = formRefs.current.GrossWeightQuantity;
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('value', calculatedValue);
                    }
                }
            }
        }

        if (name === "PriceMethod" && value!=null) {
            if (value === PriceMethodEnum.DirectPrice) {
                DisableEnableControls("PriceBasis", true, formRefs);
                DisableEnableControls("CalcMethod", true, formRefs);
                setformFields(prevState => ({
                    ...prevState,
                    CalcMethod: null
                }));
            }
            else if (value !== PriceMethodEnum.DirectPrice) {
                DisableEnableControls("PriceBasis", false, formRefs);
                DisableEnableControls("CalcMethod", false, formRefs);
                setformFields(prevState => ({
                    ...prevState,
                    CalcMethod: CalcMethodEnum.PercentMarkup
                }));
            }
        }
        if (name == "PriceSource") {
            if (value ==PriceSourceEnum.PriceCode || value ===PriceSourceEnum.ItemMaster) {
                DisableEnableControls("PriceLevelA", true, formRefs);
                DisableEnableControls("PriceLevelB", true, formRefs);
                DisableEnableControls("PriceLevelC", true, formRefs);
                DisableEnableControls("PriceLevelD", true, formRefs);
                DisableEnableControls("PriceLevelE", true, formRefs);
                DisableEnableControls("CalcMethod", true, formRefs);
                DisableEnableControls("PriceBasis", true, formRefs);
                DisableEnableControls("PriceMethod", true, formRefs);
                setformFields(prevState => ({
                    ...prevState,
                    PriceLevelA: null,
                    PriceLevelB: null,
                    PriceLevelC: null,
                    PriceLevelD: null,
                    PriceLevelE: null,
                    CalcMethod: null,
                    PriceBasis: null,
                    PriceMethod: null,
                }));
                if(value ==PriceSourceEnum.PriceCode)
                 DisableEnableControls("RPriceTable", false,formRefs);
            }
            else if (value ==PriceSourceEnum.SinglePrice) {
                DisableEnableControls("PriceLevelA", false, formRefs);
                DisableEnableControls("PriceLevelB", false, formRefs);
                DisableEnableControls("PriceLevelC", false, formRefs);
                DisableEnableControls("PriceLevelD", false, formRefs);
                DisableEnableControls("PriceLevelE", false, formRefs);
                DisableEnableControls("CalcMethod", false, formRefs);
                DisableEnableControls("PriceBasis", false, formRefs);
                DisableEnableControls("PriceMethod", false, formRefs);
                DisableEnableControls("RPriceTable", true, formRefs);
                setformFields(prevState => ({
                    ...prevState,
                    RPriceTable: null,
                    PriceMethod:PriceMethodEnum.DirectPrice,
                }));
            }
          if(value ===PriceSourceEnum.ItemMaster){
                DisableEnableControls("RPriceTable", true, formRefs);
            }
        } 


    });

    const handleUOMFormLoad = useCallback((formRefs) => {
        loadLookupFromStaticData(formRefs, "RfReceiptValidation", RfReceiptValidation);
        loadLookupFromStaticData(formRefs, "RfShipmentValidation", RfShipmentValidation);
        loadLookupFromStaticData(formRefs, "CommissionBasis", CommissionBases);
        let calculatedValue = formFields['GrossWeightQuantity'] - formFields['NetWeightQuantity'];
        if (formRefs && formRefs.current && formRefs.current['GrossMinusNet']) {
            const ref = formRefs.current['GrossMinusNet'];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    instance.option('value', calculatedValue);
                }
            }
        }

        if (formRefs && formRefs.current && formRefs.current['InventoryUnitNotUsed']) {
            const ref = formRefs.current['InventoryUnitNotUsed'];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    instance.option('value', 1);
                }
            }
        }
    });

    // Status Tab start
    const statusFormLookupsLoad = () => {
    }
    const handleStatusFieldChange = (name, value) => {

    }

    const reorderFormLoad = (formRefs) => {
        loadLookupFromStaticData(formRefs, "ReorderMethodFlag", ReorderMethodFlag);
        if (formFieldsRef.current.ReorderMethodFlag == YesNo.No) {
            setReorderControlls(true,formRefs);
        }
        else {
            setReorderControlls(false,formRefs);
        }
    }
    const costPriceFormLoad = (formRefs) => {
        loadLookupFromStaticData(formRefs, "ArTradeDiscountFlag", TradeDisc);
        loadLookupFromStaticData(formRefs, "ArTermsDiscountFlag", TradeDisc);
        loadLookupFromStaticData(formRefs, "CostBasisMethodFlag", CostBasisMethodFlag);
        loadLookupFromStaticData(formRefs, "RoundingMethod", RoundingMethod);
        loadLookupFromStaticData(formRefs, "PriceSource", PriceSource);
        loadLookupFromStaticData(formRefs, "PriceMethod", PriceMethod);
        loadLookupFromStaticData(formRefs, "CalcMethod", CalcMethod);
        if (formFieldsRef.current.PriceMethod === PriceMethodEnum.DirectPrice) {
            DisableEnableControls("PriceBasis", true,formRefs);
            DisableEnableControls("CalcMethod", true,formRefs);
            setformFields(prevState => ({
                ...prevState,
                CalcMethod: null
            }));
        }
        else if (formFieldsRef.current.PriceMethod !== PriceMethodEnum.DirectPrice) {
            DisableEnableControls("PriceBasis", false,formRefs);
            DisableEnableControls("CalcMethod", false,formRefs);
        }
        if (formFieldsRef.current.PriceSource == PriceSourceEnum.PriceCode || formFieldsRef.current.PriceSource ===PriceSourceEnum.ItemMaster) {
            DisableEnableControls("PriceLevelA", true,formRefs);
            DisableEnableControls("PriceLevelB", true,formRefs);
            DisableEnableControls("PriceLevelC", true,formRefs);
            DisableEnableControls("PriceLevelD", true,formRefs);
            DisableEnableControls("PriceLevelE", true,formRefs);
            DisableEnableControls("CalcMethod", true,formRefs);
            DisableEnableControls("PriceBasis", true,formRefs);
            DisableEnableControls("PriceMethod", true,formRefs);
            if(formFieldsRef.current.PriceSource ===PriceSourceEnum.ItemMaster){
                DisableEnableControls("RPriceTable", true, formRefs);
            }
            setformFields(prevState => ({
                ...prevState,
                PriceLevelA: null,
                PriceLevelB: null,
                PriceLevelC: null,
                PriceLevelD: null,
                PriceLevelE: null,
                CalcMethod: null,
                PriceBasis: null,
                PriceMethod: null
            }));
        }
        else if (formFieldsRef.current.PriceSource ==PriceSourceEnum.SinglePrice) {
            DisableEnableControls("PriceLevelA", false,formRefs);
            DisableEnableControls("PriceLevelB", false,formRefs);
            DisableEnableControls("PriceLevelC", false,formRefs);
            DisableEnableControls("PriceLevelD", false,formRefs);
            DisableEnableControls("PriceLevelE", false,formRefs);
            DisableEnableControls("PriceMethod", false,formRefs);
            DisableEnableControls("RPriceTable", true,formRefs);
            setformFields(prevState => ({
                ...prevState,
                RPriceTable: null
            }));
        }
    }
    //HandlingTab////////////////////////
    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Lot Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.RowId === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                 <Item location="after">
                                    <Button text="View Item" type="default" onClick={()=>setShowPopup({id:formFields.RItem,visible:true})} />
                                 </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"} onSelectionChanged={handleTabSelection}>
                                <TabItem title="Primary">
                                    <PrimaryTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} primaryFormLookupsLoad={primaryFormLookupsLoad} />
                                </TabItem>
                                <TabItem title="UOM" >
                                    <UOMTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleUOMFormLoad={handleUOMFormLoad}  />
                                </TabItem>
                                <TabItem title="Cost/Price">
                                    <CostPriceTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} costPriceFormLoad={costPriceFormLoad}  loadPriceDataGrid={loadPriceDataGrid} isTabVisible={selectedTabIndex === 2} onGridReady={costPriceGridRef} />
                                </TabItem>
                                <TabItem title="Reorder">
                                    <ReorderTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} reorderFormLoad={reorderFormLoad} />
                                </TabItem>
                                <TabItem title="User Defined">
                                    <UserDefinedTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} />
                                </TabItem>
                                <TabItem title="Status">
                                    <StatusTab formFields={formFields} setformFields={setformFields} handleStatusFieldChange={handleStatusFieldChange} statusFormLookupsLoad={statusFormLookupsLoad} />
                                </TabItem>
                                <TabItem title="Locations">
                                    <LocationsTab formFields={formFields} />
                                </TabItem>
                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>

                </div>
            </div>
           <ItemDataEntryPopup showPopup={showPopup} setShowPopup={setShowPopup}/>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
